import { render, staticRenderFns } from "./PostcardArtworkTool.vue?vue&type=template&id=01da14d3&scoped=true"
import script from "./PostcardArtworkTool.vue?vue&type=script&lang=js"
export * from "./PostcardArtworkTool.vue?vue&type=script&lang=js"
import style0 from "./PostcardArtworkTool.vue?vue&type=style&index=0&id=01da14d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da14d3",
  null
  
)

export default component.exports